/* CT 2026-09-29 — LOS ICONOS DE "CARGANDO" NO GIRAN CUANDO NO SE VEN.
 * Son SVG con <animateTransform> (SMIL): snippets/icon-cart-loading.liquid (uno dentro de cada foto de la galeria de la
 * ficha, hasta que la foto carga) y snippets/icon-loading.liquid (el boton de carga infinita al final de las colecciones).
 * La opacidad no detiene SMIL: con la pagina quieta hacian ~100 recalculos de estilo y ~100 layouts por segundo y tenian
 * el hilo principal ocupado 16-20 % del tiempo (ficha y coleccion), sumando espera a cada toque.
 * Aca se PAUSAN mientras estan fuera de pantalla (o escondidos) y se reanudan al entrar: lo que se ve es identico.
 * Solo actua sobre SVG que traen animaciones SMIL; los que el tema agrega despues (carga infinita, galeria nueva al cambiar
 * de color) se enganchan al aparecer. Medicion: tools/rapida-hilo.js y tools/rapida-smil-probar.js. */
(() => {
  if (!('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((entradas) => {
    entradas.forEach((e) => {
      const svg = e.target;
      if (typeof svg.pauseAnimations !== 'function') return;
      if (e.isIntersecting) svg.unpauseAnimations(); else svg.pauseAnimations();
    });
  }, { rootMargin: '100px' });
  const SMIL = 'animateTransform, animate, animateMotion';
  const enganchar = (raiz) => {
    if (!raiz || !raiz.querySelectorAll || !raiz.querySelector(SMIL)) return;
    const svgs = raiz.tagName && raiz.tagName.toLowerCase() === 'svg' ? [raiz] : raiz.querySelectorAll('svg');
    svgs.forEach((svg) => {
      if (svg.__ctPausa || !svg.querySelector(SMIL)) return;
      svg.__ctPausa = true;
      svg.pauseAnimations();          // arranca en pausa: el observador la reanuda si esta en pantalla
      io.observe(svg);
    });
  };
  enganchar(document);
  new MutationObserver((cambios) => {
    for (const c of cambios) for (const n of c.addedNodes) if (n.nodeType === 1) enganchar(n);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
